import { Dropdown } from "components/ui";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import {
    FOLLOW_UP_COLLECTION_WRITE_PERMISSION,
    FOLLOW_UP_TABLE_ACTIONS,
} from "../../enum";
import FollowUpCollectionAccessControl from "../../FollowUpCollectionAccessControl/FollowUpCollectionAccessControl";

const { CREATE_FOLLOW_UP_COLLECTION, DELETE_FOLLOW_UP_COLLECTION } =
    FOLLOW_UP_TABLE_ACTIONS;

const FollowUpTableActions = ({
    handleActionModal,
    hasAttachedFollowUp,
    capsuleEntry,
}) => {
    if (hasAttachedFollowUp) {
        return (
            <Dropdown
                size='sm'
                placeholder={
                    <ReactSVG
                        src={asset?.icons?.horizontalEllipsis}
                        className='d-inline-flex'
                    />
                }
                ddValueClass='borderless'
                className='table__dropdown'
                ddOptionsClass='table__dropdown'
                anchor={false}
                changeValue={false}
                onChange={({ value }) =>
                    handleActionModal(value, capsuleEntry)
                }
                options={[
                    {
                        value: DELETE_FOLLOW_UP_COLLECTION,
                        label: "Delete",
                        baseResources: FOLLOW_UP_COLLECTION_WRITE_PERMISSION,
                    },
                ]}
            />
        );
    }

    return (
        <FollowUpCollectionAccessControl>
            <AddButton
                btnText='Add follow up collection'
                otherClassName='agent-follow-up__add-button'
                onClick={() =>
                    handleActionModal(
                        CREATE_FOLLOW_UP_COLLECTION,
                        capsuleEntry
                    )
                }
            />
        </FollowUpCollectionAccessControl>
    );
};

export default FollowUpTableActions;
